module.exports = __webpack_public_path__ + "static/media/cort-furniture-large.d0494c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/cort-furniture-large.png
// module id = 755
// module chunks = 27